import { atom, useAtom } from "jotai"
import { isEqual } from "lodash"
import { v4 as uuidv4 } from "uuid"

import Alert from "../Alert"

import type { Alert as AlertType } from "../Alert"

type Toast = Omit<AlertType, "show"> & {
  show?: boolean
  uuid?: string
  content: string | React.ReactNode
}

const primitiveToastAtom = atom<Toast[]>([])

export const toastAtom = atom(
  get => get(primitiveToastAtom),
  (get, set, newToast: Toast) => {
    // set show to true initially
    newToast.show = true
    // create a uuid for the toast in case the content is the same
    newToast.uuid = uuidv4()
    set(primitiveToastAtom, [...get(primitiveToastAtom), newToast])
    // then after 5 seconds set show to false
    setTimeout(() => {
      set(
        primitiveToastAtom,
        get(primitiveToastAtom).map(t => {
          if (isEqual(t, newToast)) return { ...t, show: false }
          return t
        })
      )
    }, 5000)
  }
)

const Toast: React.FC = () => {
  const [toast] = useAtom(toastAtom)

  return (
    <div className="fixed bottom-3 left-1/2 -translate-x-1/2 flex flex-col">
      {toast.map((t, i) => (
        <Alert key={`toast-${i}`} show={t?.show || false} variant={t.variant}>
          {t.content}
        </Alert>
      ))}
    </div>
  )
}

export default Toast
